var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 12 10",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4e6294",
    d: "M6.323 5.44a.547.547 0 01-.646 0L1.091 2.078 0 1.277V9c0 .3.244.545.545.545h10.91A.545.545 0 0012 9V1.277l-1.09.8L6.322 5.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e6294",
    d: "M6 4.322L11.275.453H.724L6 4.323z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default "/_next/static/images/66a7d54682562fd9175482fb76608f04.svg";
export { ForwardRef as ReactComponent };